export default "__VITE_ASSET__DnM2y4eN__"